module.exports = __webpack_public_path__ + "img/twob-bg.255fdd1e.jpg";